module.exports = __webpack_public_path__ + "media/parallax/separated-leaves-05-89bf5229.svg";